import React from "react";
import "../../styles/pages/_home.css";
import {
  FaPlane,
  FaHospital,
  FaUniversity,
  FaIndustry,
  FaShippingFast,
  FaCloud,
} from "react-icons/fa";

export default function IndustriesSection() {
  const industries = [
    { icon: <FaPlane />, name: "Aviation", color: "#0b5cff" },
    { icon: <FaHospital />, name: "Healthcare", color: "#e63946" },
    { icon: <FaUniversity />, name: "Education", color: "#2a9d8f" },
    { icon: <FaIndustry />, name: "Manufacturing", color: "#f4a261" },
    { icon: <FaShippingFast />, name: "Logistics", color: "#1d3557" },
    { icon: <FaCloud />, name: "Technology", color: "#6a4c93" },
  ];

  // repeat to avoid gaps during scroll
  const repeatedIndustries = [...industries, ...industries, ...industries];

  return (
    <section className="industries-section">
      <div className="industries-head">
        <h2>Industries We Support</h2>
        <p>Partnering across sectors with tailored solutions for real impact.</p>
      </div>

      <div className="industries-marquee">
        <div className="industries-track">
          {repeatedIndustries.map((item, i) => (
            <div className="industry-item" key={i}>
              <span
                className="industry-icon"
                style={{ color: item.color }}
              >
                {item.icon}
              </span>
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
